<template>
  <div class="bg-main_blue">
    <div class="md:px-10 max-w-screen-2xl mx-auto px-6 lg:px-12 py-12">
      <div class="relative bg-gray-100 h-auto min-h-[14rem] rounded-lg p-6 sm:p-8 mt-12 sm:mt-16">
        <!-- Quote Icon -->
        <div class="absolute -top-6 left-4 sm:left-6">
          <i class="fa-solid fa-quote-left text-yellow text-4xl sm:text-5xl"></i>
        </div>

        <div class="flex flex-col md:flex-row justify-between items-center gap-8">
          <!-- Text -->
          <div class="w-full md:flex-1 mt-8 md:mt-10">
            <p class="text-gray-700 text-justify text-base sm:text-lg leading-relaxed">
              Life isn't a race to the finish line; it's a journey of planting seeds. Some will bloom quickly, others in their own season. Your job is to nurture every moment with faith and patience, knowing each step matters.
            </p>
          </div>

          <!-- Image -->
          <div class="w-full md:w-auto flex flex-col items-center md:items-end text-center md:text-right space-y-2">
            <img
              src="../assets/images/about-barka.jpeg"
              alt="Barkas Illustration"
              class="w-24 h-24 sm:w-28 sm:h-28 rounded-full shadow-lg mb-2 lg:-mt-20"
            />
            <h2 class="text-base sm:text-lg font-semibold text-gray-800 leading-tight">
              Arc. Dr. Barka Umaru Mshelia
            </h2>
            <p class="text-sm text-gray-600">GMD Mshel Group</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="py-12 sm:py-16 text-center px-4">
    <div class="bg-white rounded-3xl p-6 sm:p-8 shadow-lg border border-gray-100 max-w-4xl mx-auto">
      <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
        Ready to Build the Future Together?
      </h3>
      <p class="text-gray-600 mb-6 max-w-2xl mx-auto text-sm sm:text-base">
        Join us in our mission to transform industries and communities across Africa through innovation, quality, and sustainable growth.
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <router-link to="/services" class="bg-yellow text-white px-6 sm:px-8 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
          Learn More
        </router-link>
        <router-link to="/contact-us" class="border-2 border-gray-300 text-gray-700 px-6 sm:px-8 py-3 rounded-full font-semibold hover:border-gray-400 hover:bg-gray-50 transition-all duration-300">
          Contact Us
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
